<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>sustained rating</mat-label>
                <input matInput type="number" placeholder="sustained rating"
                       [formField]="form().sustainedRating" />
                <span matSuffix>A</span>
                @for (error of form().sustainedRating().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>cables in parallel, at rating</mat-label>
                <input matInput type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="number in parallel"
                       [formField]="form().parallelCables" />
                @for (error of form().parallelCables().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


        <div>
            <mat-form-field>
                <mat-label>reference temperature at rating</mat-label>
                <input matInput type="number" placeholder="rating reference temperature"
                       [formField]="form().referenceTemperature" />
                <span matSuffix>°C</span>
                @for (error of form().referenceTemperature().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


    </div>

</form>
